import { applyTransaction, Store, StoreConfig } from '@datorama/akita';
import { IToken } from 'core/services/sessionAPIService';
import { IUser } from 'modules/users/models/user.model';
import { usersStore } from 'modules/users/state/users.store';
import { ISession } from '../models/session.model';

const createInitialState = (): ISession => {
    return {
        token: null,
        refreshToken: null,
        me: null,
    };
};

@StoreConfig({ name: 'session', resettable: true })
export class SessionStore extends Store<ISession> {
    constructor() {
        super(createInitialState());
    }

    updateCurrent(user: IUser): void {
        applyTransaction(() => {
            usersStore.upsert(user.id, user);
            this.update({ me: user.id });
            this.setError(null);
        });
    }

    handleToken({ token, refreshToken, user }: IToken): void {
        applyTransaction(() => {
            usersStore.upsert(user.id, user);
            this.update({ token, refreshToken, me: user.id });
            this.setError(null);
        });
    }
}

export const sessionStore = new SessionStore();
